"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainlink = void 0;
exports.chainlink = {
    VRFCoordinator: '0x747973a5A2a4Ae1D3a8fDF5479f1514F65Db9C31',
};
